<!--
 * @Description:跟进记录 - 线索/客户详情
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-05-05 14:45:39
 * @LastEditors: cxh
-->
<template>
  <cos-table
    :columns="columns"
    serial
    rowKey="id"
    @fetch="fetch"
    ref="tableRef"
    :tableId="`${route.path}_TabsClueCosFollowUp`"
  >
    <template #bodyCell="{ column, record, text }">
      <template v-if="column.dataIndex === 'startTime'">
        <p>{{ text }}~{{ record.endTime }}</p>
      </template>
      <template v-if="column.dataIndex === 'chanceName'">
        <BusinessName :appId="appId" :value="text" v-if="text" />
        <p v-else>--</p>
      </template>
      <template v-if="column.dataIndex === 'process'">
        <EditorTableText :value="text" />
      </template>
      <template v-if="column.dataIndex === 'action'">
        <a-button type="link" @click="handleDetail(record)">{{ t('btn.detail') }}</a-button>
        <a-button type="link" @click="handleDel(record)" v-permission="permissionPage?.del">{{
          t('btn.del')
        }}</a-button>
        <a-button type="link" @click="handleEdit(record)" v-permission="permissionPage?.edit">{{
          t('btn.edit')
        }}</a-button>
        <a-button
          type="link"
          @click="handleCommit(record)"
          v-permission="props.appId === 'cos_lbu' ? 'lbu_follow_comment_btn' : permissionPage?.comment"
          >{{ t('btn.comment') }}</a-button
        >
      </template>
    </template>
  </cos-table>
</template>
<script setup lang="ts">
import { ref, PropType, computed, reactive, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ParamCodeParams } from '@/typings/common'
import { listByParamCodes } from '@/api/common'
import Modal from '@/hooks/modalType'
import { DcMessage } from '@dc-platform/dc-components'
import EditorTableText from '@/components/Editor/src/tableText.vue'
import { clueAndcustomerPhaseEnum as fbuClueAndcustomerPhaseEnum } from '@/views/gucangSales/commonEnum/dataConfig'
import { clueAndcustomerPhaseEnum as ofbuClueAndcustomerPhaseEnum } from '@/views/overseasSales/commonEnum/dataConfig'
import { clueAndcustomerPhaseEnum as lbuClueAndcustomerPhaseEnum } from '@/views/yuntuSales/commonEnum/dataConfig'
import type { FbuFollowUpRecordItem } from '@/typings/api/followUpManage'
import BusinessName from '@/components/BusinessName/index.vue'
import request from '@/utils/request'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const route = useRoute()
const router = useRouter()
const loading = ref(false)
const tableRef = ref()
const props = defineProps({
  edit: {
    type: Boolean,
    default: false
  },
  clueCosId: String,
  disabled: {
    type: Boolean,
    default: true
  },
  appId: {
    type: String as PropType<ParamCodeParams['appId']>,
    default: 'cos_fbu'
  },
  permissionPage: {
    type: Object as PropType<{
      edit: string
      del: string
      comment?: string
    }>,
    default: () => {
      return {}
    }
  },
  showFooter: {
    type: Boolean,
    default: false
  },
  workCode: {
    // 线索负责人
    type: String
  },
  followRefId: String, //  线索客户id
  chanceId: String // 商机id
})
const paramCodeData = reactive<{
  follow_mode: []
  follow_purpose: []
}>({
  follow_mode: [], // 拜访方式
  follow_purpose: [] // 访客目的
})
const appIdEumn = computed(() => {
  return eumn[props.appId]
})
const eumn = {
  cos_fbu: 'fbu',
  cos_lbu: 'lbu',
  cos_zbu: 'zbu',
  cos_ofbu: 'ofbu'
}
const dataConfigEnum = {
  cos_fbu: fbuClueAndcustomerPhaseEnum,
  cos_ofbu: ofbuClueAndcustomerPhaseEnum,
  cos_lbu: lbuClueAndcustomerPhaseEnum
}
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: props.appId,
    paramCodes: [`${appIdEumn.value}_follow_mode`, `${appIdEumn.value}_follow_purpose`]
  }).then((res) => {
    if (res.code === 200) {
      paramCodeData.follow_mode = res.data[`${appIdEumn.value}_follow_mode`]
      paramCodeData.follow_purpose = res.data[`${appIdEumn.value}_follow_purpose`]
    }
  })
}
const fetch = async (params: object, callBack: (res: any) => void) => {
  request
    .post(`${appIdEumn.value}/api/followRecords/page`, {
      ...params,
      chanceId: props.chanceId,
      followRefId: props.followRefId
    })
    .then((res) => {
      callBack(res)
    })
}
// 详情
const handleDetail = (record: FbuFollowUpRecordItem) => {
  router.push({
    path: `/${appIdEumn.value}/followUpRecord/view`,
    query: {
      id: record.id
    }
  })
}
// 删除
const handleDel = (record: FbuFollowUpRecordItem) => {
  loading.value = true
  Modal.delete({
    async onOk() {
      if (record.id) {
        request.delete(`${appIdEumn.value}/api/followRecords/${record.id}`).then((res) => {
          DcMessage.success(t('tips.delSuccess'))
          tableRef.value.delFetch()
          loading.value = false
        })
      }
    }
  })
}

// 编辑
const handleEdit = (record: FbuFollowUpRecordItem) => {
  router.push({
    path: `/${appIdEumn.value}/followUpRecord/edit`,
    query: {
      id: record.id,
      returnPath: route.fullPath
    }
  })
}
// 评论
const handleCommit = (record: FbuFollowUpRecordItem) => {
  router.push({
    path: `/${appIdEumn.value}/followUpRecord/commit`,
    query: {
      id: record.id,
      returnPath: route.fullPath
    }
  })
}
const columns = computed(() => {
  if (props.appId === 'cos_fbu' || props.appId === 'cos_ofbu') {
    return [
      {
        title: t('follow.stage'),
        dataIndex: 'stage',
        dicData: dataConfigEnum[props.appId]
      },
      { title: t('follow.purpose'), dataIndex: 'fbuPurpose', dicData: paramCodeData.follow_purpose },
      { title: t('follow.fllowTime'), dataIndex: 'startTime', width: 310 },
      { title: t('follow.createByName'), dataIndex: 'createByName' },
      { title: t('follow.customerContactName'), dataIndex: 'contactName', width: 150 },
      { title: t('follow.dutyByName'), dataIndex: 'dutyByName' },
      { title: t('follow.preCustomerName'), dataIndex: 'preFollowRefName' },
      { title: t('follow.processDetail'), dataIndex: 'process', width: 450 },
      {
        title: t('common.action'),
        dataIndex: 'action',
        fixed: 'right',
        langWidth: {
          zh: 220,
          en: 310
        }
      }
    ]
  } else {
    return [
      {
        title: '客户名称',
        dataIndex: 'customerName',
        fixed: 'left'
      },
      { title: '客户阶段', dataIndex: 'stage', dicData: dataConfigEnum[props.appId] },
      { title: '联系人姓名', dataIndex: 'contactName' },
      { title: '关联商机', dataIndex: 'chanceName' },
      { title: '目的', dataIndex: 'lbuPurpose' },
      { title: '跟进过程', dataIndex: 'process' },
      { title: '结果/后续', dataIndex: 'result' },
      { title: '当前遇到的问题', dataIndex: 'problem', width: 210 },
      { title: '跟进人', dataIndex: 'dutyByName', width: 100 },
      { title: '跟进方式', dataIndex: 'mode', dicData: paramCodeData.follow_mode },
      { title: '跟进时间', dataIndex: 'startTime', width: 310 },
      { title: '创建人', dataIndex: 'createByName', width: 190 },
      { title: '创建时间', dataIndex: 'createTime', width: 190 },
      { title: '操作', dataIndex: 'action', fixed: 'right', width: 220 }
    ]
  }
})
onMounted(() => {
  getByParamCodes()
})
</script>
<script lang="ts">
export default { name: 'OperationLog' }
</script>
<style lang="scss" scoped></style>
